<template>
  <div>
    <div
      v-if="bannerMessage"
      class="w-full bg-red-600 text-white text-center text-lg px-4 mb-3 w-full"
    >
      {{ bannerMessage }}
    </div>
    <nav class="flex items-center justify-between flex-wrap">
      <div class="flex items-center flex-shrink-0 text-white mr-6 mb-2 md:mx-0">
        <a href="https://www.philasd.org" target="_blank">
          <img
            class="logo"
            alt="The School District of Philadelphia"
            src="~/assets/images/logo.png"
          />
        </a>
      </div>
      <div><slot /></div>
      <div class="flex md:justify-end items-center w-full md:w-auto">
        <div class="w-full">
          <HeaderButton label="About" route="/about">
            <GlossaryIcon />
          </HeaderButton>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import HeaderButton from './HeaderButton'
import GlossaryIcon from '~sdp-components/Icons/GlossaryIcon'

export default {
  components: {
    HeaderButton,
    GlossaryIcon
  },
  props: {
    bannerMessage: {
      type: String,
      required: false,
      default: undefined
    }
  }
}
</script>

<style scoped>
.logo {
  max-width: 310px;
  height: auto;
}
</style>
